// lib
import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
// src
import { useResize } from "utils/hooks";
import Calendar from "containers/plannings/table/calendar/Calendar";
import Timeline from "containers/plannings/table/timeline/Timeline";
import Warning from "components/partials/Warning";
import Aside from "components/plannings/partials/Aside";
import EventModal from "./modal/EventModal";

const Table = ({
  // data props
  identity,
  isLarge,
  isLight,
  isLoadingInRange,
  notManagedByGeode,
  showNetworkError,
  view,
  // action props
  discardNetworkError,
}) => {
  // Keeps track of max height *only* for components who needs it (Calendar, at least
  // to enable scrollToTime)
  const calcHeight = () => window.innerHeight - 72; // 52 for Appbar + 2x10 for padding
  const [maxHeight, setMaxHeight] = useState(calcHeight());
  useResize(() => setMaxHeight(calcHeight()));
  const maxHeightProps = view === "timeline" ? { maxHeight: "auto" } : { maxHeight };
  const { t } = useTranslation();

  // ---- Modal ----
  const [openModalWith, setOpenModalWith] = useState(null);
  const handleOpenModal = (event) => {
    if (event.visibility.id !== "PRI") {
      setOpenModalWith(event);
    }
  };
  const handleCloseModal = () => {
    setOpenModalWith(null);
  };

  // ---- Snackbar ----
  const [hideSnackbar, setHideSnackbar] = useState(false);
  const handleCloseSnackbar = () => setHideSnackbar(true);

  let TableSwitch;
  if (view === "timeline") {
    TableSwitch = Timeline;
  } else {
    TableSwitch = Calendar;
  }
  return (
    <>
      {!isLight && isLarge && <Aside {...maxHeightProps} />}
      <main>
        <TableSwitch handleOpenModal={handleOpenModal} {...maxHeightProps} />
      </main>
      <EventModal event={openModalWith} identity={identity} open={Boolean(openModalWith)} onClose={handleCloseModal} />
      <Warning
        open={!isLoadingInRange && !hideSnackbar && notManagedByGeode}
        onClose={handleCloseSnackbar}
        message={t("errors.geode")}
      />
      <Warning
        open={showNetworkError}
        onClose={() => discardNetworkError()}
        message={t("errors.server")}
      />
    </>
  );
};

Table.propTypes = {
  // data props
  identity: PropTypes.object,
  isLight: PropTypes.bool.isRequired,
  isLarge: PropTypes.bool.isRequired,
  isLoadingInRange: PropTypes.bool.isRequired,
  notManagedByGeode: PropTypes.bool.isRequired,
  showNetworkError: PropTypes.bool.isRequired,
  view: PropTypes.string.isRequired,
  // ations props
  discardNetworkError: PropTypes.func.isRequired,
};

Table.defaultProps = {
  identity: { id: "", firstName: "", lastName: "" },
};

export default Table;
